export default class Swell {
  constructor(options = {}) {
    const { height, direction, period } = options

    this.height = height || null
    this.direction = direction || null
    this.period = period || null
  }
}
